import { css } from '@emotion/css';

export const presenceNotificationBlock = css`
	.notification {
		max-width: 200px;
	}
`;
